module.exports = __webpack_public_path__ + "de6d10dbef854ed7f924e269b44728ca.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/body/mer-tail-purple-s.png
// module id = 1313
// module chunks = 0